import React from "react";
import { message, Modal, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";

const DELETECARD = gql`
  mutation removeCard($id: ID!) {
    removeCard(id: $id)
  }
`;

function DeleteCard({ id, name, children, onDeleteCard, closeDrawer }) {
  const [runDeleteCard, deleteCard] = useMutation(DELETECARD, {
    onCompleted({ removeCard }) {
      if (removeCard) {
        message.success(`کارت ${name ? name : ""} حذف شد.`);
        onDeleteCard();
        closeDrawer();
      } 
    },
    onError(err) {
      console.log(err.message);
    },
  });

  const doDeleteCard= () => {
    runDeleteCard({
      variables: { id },
    });
  };
  return (
    <>
      <Popconfirm
        title={`حذف ${name ? `کارت ${name}` : "کارت"}?`}
        okText="حذف"
        cancelText="خیر"
        onConfirm={doDeleteCard}
      >
        <span>{children}</span>
      </Popconfirm>
    </>
  );
}

export default DeleteCard;
